module.exports = __webpack_public_path__ + "assets/img/intelligentControl_b.22c5b660.png";